import template from './agentDownloadLink.html';
import controller from './agentDownloadLink.controller';

let agentDownloadLinkComponent = ($timeout,config) => {
  return {
    restrict: 'E',
    scope: {},
    template,
    controller,
    controllerAs: 'vm',
    link: ($scope, $elem, $attrs, $ctrl) => {
      $timeout(()=>{
        $ctrl.getSignedDownloadUrl(config);
      },0);
    }
  };

};

agentDownloadLinkComponent.$inject = ['$timeout','config'];

export default agentDownloadLinkComponent;



// WEBPACK FOOTER //
// ./app/components/agentDownloadLink/agentDownloadLink.component.js